<template>
  <div
    class="player"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <template v-if="doubleCountryType.includes(sportCompetitionType)">
      <div
        class="doubleCountryType"
        v-for="item in playerInfos"
        :key="item.playerId"
      >
        <div class="name-box">
          <span v-text="_valPerFormatHandler(item.playerName)"></span>
        </div>
        <div class="country-box">
          <span class="country_logo">
            <img v-if="item.countryLogo" :src="item.countryLogo" alt="" />
          </span>
          <span
            class="country-name"
            v-text="_valPerFormatHandler(item.countryName)"
          ></span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="name-box" v-for="item in playerInfos" :key="item.playerId">
        <span v-text="_valPerFormatHandler(item.playerName)"></span>
      </div>
      <div class="country-box">
        <span class="country_logo">
          <img :src="countryImg" alt="" />
        </span>
        <span
          class="country-name"
          v-text="_valPerFormatHandler(countryName)"
        ></span>
      </div>
    </template>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，球员数组
    playerInfos: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 必传参数，国家图片
    countryImg: {
      type: String,
      // default: 'https://mms-voice.cdn.bcebos.com/ressync/voiceability/taste/voice_matcher_day.png'
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: 'calc(7.64vw * var(--mixtmt_mixvw))',
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    sportCompetitionType: {
      type: String, //`${competitionType}_${sportType}`:这个主题中网双打一个球队里面是个不同国籍的运动员（取运动员playerInfos中的[countryLogo,countryName]），其他赛事下只展示一个国旗(取国家teamLogo)
      default: '',
    },
  },
  data() {
    return {
      doubleCountryType: ['tennis_chinaOpen'],
    }
  },
  methods: {
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.player {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: calc(7.64vw * var(--mixtmt_mixvw));
  .doubleCountryType {
    .country-box {
      padding: calc(0.416vw * var(--mixtmt_mixvw)) 0
        calc(1.68vw * var(--mixtmt_mixvw)) 0;
    }
  }
  .img-box {
    position: relative;
    width: calc(6.25vw * var(--mixtmt_mixvw));
    height: calc(8.33vw * var(--mixtmt_mixvw));
    background-size: 100% auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-image: var(--mixtmt_default_playerLogo);
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
    &.isLogo {
      background-image: none;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .name-box {
    margin: calc(0.556vw * var(--mixtmt_mixvw)) 0
      calc(0.833vw * var(--mixtmt_mixvw)) 0;
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor_main);
    line-height: calc(1.25vw * var(--mixtmt_mixvw));
    text-align: center;
  }
  .country-box {
    padding-top: calc(1.388vw * var(--mixtmt_mixvw));
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .country_logo {
      position: relative;
      width: calc(2.498vw * var(--mixtmt_mixvw));
      height: calc(1.666vw * var(--mixtmt_mixvw));
      margin-right: calc(0.694vw * var(--mixtmt_mixvw));
      overflow: hidden;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .country-name {
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor_main);
      line-height: calc(1.666vw * var(--mixtmt_mixvw));
      vertical-align: top;
    }
  }
}
</style>
